import { FirebaseAuthHandler, FirebaseStorageHandler } from '@packages/firebase-helper';
import { GoogleAuthProvider, getAuth } from 'firebase/auth';
import { getApp, getApps, initializeApp } from 'firebase/app';

import { FIREBASE_CONFIG } from '@/configs';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
	apiKey:            FIREBASE_CONFIG.API_KEY,
	appId:             FIREBASE_CONFIG.APP_ID,
	authDomain:        FIREBASE_CONFIG.AUTH_DOMAIN,
	messagingSenderId: FIREBASE_CONFIG.MESSAGING_SENDER_ID,
	projectId:         FIREBASE_CONFIG.PROJECT_ID,
	storageBucket:     FIREBASE_CONFIG.STORAGE_BUCKET,
};

export const firebaseApp = getApps().length
	? getApp()
	: initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);

export const firebaseStorageHandler = new FirebaseStorageHandler(storage);
export const firebaseHandler = new FirebaseAuthHandler(firebaseAuth);
export const GoogleProvider = new GoogleAuthProvider();
